exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Top-module__wrapper___1SAUe{position:absolute;top:0;left:0;padding:.75rem .75rem 0;display:grid;grid-template-columns:1fr auto;width:100%}.Top-module__wrapper___1SAUe .Top-module__top-right-buttons___1Ny2X{display:grid;grid-auto-flow:column;gap:.5rem}@media screen and (min-width:525px){.Top-module__wrapper___1SAUe .Top-module__top-right-buttons___1Ny2X{gap:1rem}}.Top-module__wrapper___1SAUe button svg{font-size:14px}", ""]);

// exports
exports.locals = {
	"wrapper": "Top-module__wrapper___1SAUe",
	"top-right-buttons": "Top-module__top-right-buttons___1Ny2X"
};